<template>
  <div class="chart_wrap__item" v-if="chartData && chartData.length">
    <div class="chart_wrap__item--chart">
      <h4 v-if="title">{{ title }}</h4>
      <div class="pa-2">
        <GChart
          :type="type"
          :data="chartData"
          :options="chartOptions"
        />
        <slot name="additional" />
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts/legacy'
import { mapGetters } from "vuex";

  export default {
    name: 'Diagram',
    props: ['chartData', 'title', 'options', 'type'],
    components: {GChart},
    data() {
      return {
        defaultOptions: {
          chartArea: { left: 0, top: 0, width: '100%', height: '100%' },
          backgroundColor: 'transparent',
        },
      }
    },
    computed: {
      ...mapGetters(['darkTheme']),
      chartOptions() {
        return {
          ...this.defaultOptions,
          ...this.options
        }
      }
    }
  }
</script>
